import React, { useEffect, useState } from 'react';
import { MdClose } from 'react-icons/md';
import { FiExternalLink } from 'react-icons/fi';
import { FiMinimize } from 'react-icons/fi';
import { Link } from 'react-router-dom';

import { DataState } from '../../context/DataProvider';
import {
  getGmailEmailDetailsFromDB,
  getOutlookEmailThread,
  getOutlookEmailDetailsFromDB,
  getGmailEmailThread,
} from '../../services/api';
import TriggerForm from '../form/TriggerForm';
import EmailConversation from './EmailConversation';
import EmailIframe from '../chat/EmailIframe';
import { convertToIST } from '../../utils/dateTimeUtils';
import EmailContent from './EmailContent';

const EmailComponent = ({
  messageId,
  analytics,
  onClose,
  isOutlook,
  isDialog = false,
  isAnalyticsView,
  setIsAnalyticsView,
  isGmail,
}) => {
  const [email, setEmail] = useState({});
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [conversationLoading, setConversationLoading] = useState(true);

  const [outlookEmailThread, setOutlookEmailThread] = useState([]);

  const [isModalOpen, setModalOpen] = useState(false);
  const closeModal = () => setModalOpen(false);

  const { userGoogleId } = DataState();

  useEffect(() => {
    const setMessageDetails = async () => {
      if (!messageId) {
        return;
      }

      try {
        let message_data = null;
        if (isOutlook) {
          message_data = await getOutlookEmailDetailsFromDB(
            messageId,
            userGoogleId,
          );
        } else {
          message_data = await getGmailEmailDetailsFromDB(
            messageId,
            userGoogleId,
          );
        }

        const { time, date } = convertToIST(message_data.date);
        message_data.time = time;
        message_data.date = date;
        // if (!isOutlook) {
        //   message_data.from = parseEmailList(message_data.from)
        //   message_data.to = parseEmailList(message_data.to)
        // } else {
        message_data.from.email =
          message_data.from?.address || message_data.from?.contact;
        message_data.from = [message_data.from];
        message_data.to = message_data.to?.map((to) => {
          return { ...to, email: to.address || to.contact };
        });
        message_data.attachments = (message_data.attachments || []).map(
          (attachment) => {
            return {
              ...attachment,
              mimeType: attachment.contentType,
              attachmentId: attachment.id,
              filename: attachment.name,
            };
          },
        );
        setEmail(message_data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    setMessageDetails();
    // eslint-disable-next-line
  }, [messageId]);

  const toggleView = () => {
    setIsAnalyticsView(!isAnalyticsView);
  };

  useEffect(() => {
    setConversationLoading(true);
    const fetchEmailConversations = async () => {
      try {
        let response = null;
        if (isOutlook) {
          response = await getOutlookEmailThread(
            userGoogleId,
            email?.conversationId,
          );
        } else {
          response = await getGmailEmailThread(
            userGoogleId,
            email?.conversationId,
          );
        }
        if (response?.emails?.length > 0) {
          setOutlookEmailThread(response.emails);
          setConversationLoading(false);
        }
        if (response?.emails?.length > 0) {
          setOutlookEmailThread(response.emails);
          setConversationLoading(false);
        }
      } catch (error) {
        setConversationLoading(false);
      }
    };

    if (email) {
      fetchEmailConversations();
    }
    // eslint-disable-next-line
  }, [email]);

  return (
    // eslint-disable-next-line
    <div
      className={`${
        isDialog
          ? 'flex justify-center'
          : 'fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm'
      }`}
      onClick={isDialog ? onClose : undefined}
    >
      {/* eslint-disable-next-line */}
      <div
        className={`flex min-h-[300px] flex-col bg-gray-100 pl-2 pr-6 pt-2 ${isDialog ? 'w-full' : 'w-2/3'} rounded-lg shadow-md`}
        onClick={(e) => e.stopPropagation()}
      >
        <TriggerForm
          isModalOpen={isModalOpen}
          closeModal={closeModal}
          isDialog={true}
        />

        <div className="mt-2 flex w-full flex-row">
          <div className="flex w-full flex-col">
            <div className="mb-2 flex w-full flex-col justify-between sm:flex-row sm:items-center">
              {loading ? (
                <div className="mb-2 ml-2 h-6 w-72 animate-pulse rounded bg-gray-300 sm:mb-0 sm:ml-12 sm:w-96" />
              ) : (
                <h2 className="mb-2 text-lg font-semibold text-gray-900 sm:mb-0 sm:ml-12 sm:text-xl">
                  {isAnalyticsView
                    ? 'Email Analytics'
                    : email.subject || 'No Subject'}
                </h2>
              )}

              <div className="flex flex-wrap items-center gap-2 max-sm:justify-between sm:mr-4 sm:gap-4">
                <button
                  className={`flex items-center justify-center rounded px-3 py-1 text-sm text-white transition ${
                    loading
                      ? 'h-6 w-14 animate-pulse bg-gray-300'
                      : 'bg-zinc-500 hover:bg-zinc-600'
                  }`}
                  onClick={toggleView}
                  disabled={loading}
                >
                  {loading ? '' : isAnalyticsView ? 'View Email' : 'AI View'}
                </button>

                <div className="flex items-center gap-2">
                  {/* {loading ? (
                  <div className="w-6 h-6 bg-gray-300 rounded animate-pulse"></div>
                ) : (
                  <button className="text-gray-500 hover:text-gray-700">
                    <LuPrinter size={20} />
                  </button>
                )} */}

                  {loading ? (
                    <div className="h-6 w-6 animate-pulse rounded bg-gray-300"></div>
                  ) : (
                    <Link
                      target="_blank"
                      to={
                        isOutlook
                          ? email?.webLink
                          : `https://mail.google.com/mail/u/0/#all/${messageId}`
                      }
                    >
                      <button className="text-gray-500 hover:text-gray-700">
                        <FiExternalLink size={20} />
                      </button>
                    </Link>
                  )}

                  <button
                    className="text-gray-500 hover:text-gray-700"
                    onClick={() => {
                      setIsAnalyticsView(false);
                      onClose();
                    }}
                  >
                    <MdClose size={20} />
                  </button>
                </div>
              </div>
            </div>
            <EmailContent
              email={email}
              emailThread={outlookEmailThread}
              loading={loading}
              isAnalyticsView={isAnalyticsView}
              messageId={messageId}
              isDialog={isDialog}
              isOutlook={isOutlook}
              setIsFullScreen={setIsFullScreen}
            />
            {conversationLoading ? (
              <div className="h-6 w-full animate-pulse rounded bg-gray-300"></div>
            ) : (
              outlookEmailThread.slice(1).length > 0 && (
                <EmailConversation
                  outlookEmailThread={outlookEmailThread.slice(1)}
                  setLoading={setConversationLoading}
                  loading={conversationLoading}
                />
              )
            )}
          </div>
        </div>
      </div>

      {isFullScreen && (
        <div className="fixed inset-0 z-50 h-screen w-screen bg-white p-6">
          {/* Close button stays fixed at top-right */}
          <button
            className="absolute bottom-8 right-14 mb-4 transform rounded-full bg-gray-200 p-2 text-gray-500 transition-all hover:scale-110 hover:bg-gray-300 hover:text-gray-700"
            onClick={(e) => {
              e.stopPropagation();
              setIsFullScreen(false);
            }}
          >
            <FiMinimize size={24} />
          </button>

          {/* eslint-disable-next-line */}
          <div
            onClick={(e) => e.stopPropagation()}
            className="scrollbar-thumb-gray-500 scrollbar-track-gray-200 h-full overflow-y-hidden"
          >
            {/* <article
                dangerouslySetInnerHTML={{ __html: email.body }}
                className="text-gray-700 whitespace-pre-line"
              /> */}
            <EmailIframe emailBody={email.body}></EmailIframe>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmailComponent;
